/* QUICK SHOP SIZE GUIDE OVER QUICK MODAL
   Add this AFTER theme.js.
   Do not edit theme.js for this fix. */
(function () {
  'use strict';

  var BUTTON_SELECTOR =
    '.js-drawer-open-size-guide, ' +
    '[aria-controls="SizeGuideDrawer"], ' +
    '[aria-controls^="SizeGuideDrawer-modal"]';

  var STYLE_ID = 'quick-shop-size-guide-overlay-style';

  var activeDrawer = null;
  var activeButton = null;
  var originalParent = null;
  var originalNextSibling = null;

  function addStyles() {
    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');

    style.id = STYLE_ID;

    style.textContent = [
        '.quick-shop-size-guide-overlay {',
        '  position: fixed;',
        '  inset: 0;',
        '  z-index: 2147482998;',
        '  background: rgba(0, 0, 0, 0.28);',
        '  opacity: 0;',
        '  visibility: hidden;',
        '  transition: opacity 0.3s ease, visibility 0.3s ease;',
        '}',

        '.quick-shop-size-guide-overlay.is-open {',
        '  opacity: 1;',
        '  visibility: visible;',
        '}',

        'body > .quick-shop-size-guide-drawer {',
        '  position: fixed !important;',
        '  top: 0 !important;',
        '  right: 0 !important;',
        '  bottom: 0 !important;',
        '  left: auto !important;',
        '  width: min(820px, 100vw) !important;',
        '  max-width: 100vw !important;',
        '  height: 100vh !important;',
        '  z-index: 2147482999 !important;',
        '  transform: translate3d(100%, 0, 0) !important;',
        '  transition: transform 0.4s ease, visibility 0.4s ease !important;',
        '  visibility: hidden !important;',
        '  opacity: 1 !important;',
        '  pointer-events: none !important;',
        '}',

        'body > .quick-shop-size-guide-drawer.drawer--is-open {',
        '  transform: translate3d(0, 0, 0) !important;',
        '  visibility: visible !important;',
        '  opacity: 1 !important;',
        '  pointer-events: auto !important;',
        '}'
    ].join('\n');

    document.head.appendChild(style);
    }

  function getOverlay() {
    var overlay = document.getElementById(
      'quick-shop-size-guide-overlay'
    );

    if (overlay) return overlay;

    overlay = document.createElement('div');

    overlay.id = 'quick-shop-size-guide-overlay';
    overlay.className = 'quick-shop-size-guide-overlay';
    overlay.setAttribute('aria-hidden', 'true');

    overlay.addEventListener('click', function () {
      closeDrawer();
    });

    document.body.appendChild(overlay);

    return overlay;
  }

  function getQuickModal(button) {
    return button.closest(
      '[id^="QuickShopModal-"], ' +
      '[id^="QuickShop-"], ' +
      '.quick-product__modal, ' +
      '.modal--quick-shop, ' +
      '.modal'
    );
  }

  /*
   * Build every possible size-guide drawer ID.
   *
   * Example:
   * SizeGuideDrawer-modal
   *
   * Will search:
   * SizeGuideDrawer-modal
   * SizeGuideDrawer
   */
  function getPossibleDrawerIds(button) {
    var controls =
      button.getAttribute('aria-controls') || '';

    var ids = [];

    if (controls) {
      ids.push(controls);
    }

    if (
      controls === 'SizeGuideDrawer-modal' ||
      controls.indexOf('SizeGuideDrawer-modal-') === 0
    ) {
      ids.push('SizeGuideDrawer');
    }

    if (controls === 'SizeGuideDrawer') {
      ids.push('SizeGuideDrawer-modal');
    }

    /*
     * Always include both common IDs as fallbacks.
     */
    ids.push('SizeGuideDrawer-modal');
    ids.push('SizeGuideDrawer');

    /*
     * Remove duplicates.
     */
    return ids.filter(function (id, index, allIds) {
      return id && allIds.indexOf(id) === index;
    });
  }

  function findDrawerById(scope, drawerId) {
    if (!scope || !drawerId) return null;

    /*
     * Use an attribute selector instead of querySelector("#id")
     * so special characters do not cause selector errors.
     */
    return scope.querySelector(
      '[id="' + drawerId + '"]'
    );
  }

  function findDrawer(button) {
    var possibleIds = getPossibleDrawerIds(button);
    var quickModal = getQuickModal(button);
    var drawer = null;

    /*
     * Search inside the clicked Quick Shop modal first.
     * This ensures we use the correct product's size guide.
     */
    if (quickModal) {
      for (var i = 0; i < possibleIds.length; i++) {
        drawer = findDrawerById(
          quickModal,
          possibleIds[i]
        );

        if (drawer) {
          console.log(
            '[QUICK SIZE GUIDE] Local drawer found:',
            possibleIds[i]
          );

          return drawer;
        }
      }

      /*
       * Fallback using drawer classes inside Quick Shop.
       */
      drawer = quickModal.querySelector(
        '.size-guide-drawer, ' +
        '.drawer--right.size-guide-drawer'
      );

      if (drawer) {
        console.log(
          '[QUICK SIZE GUIDE] Local drawer found by class:',
          drawer.id
        );

        return drawer;
      }
    }

    /*
     * Search the full document as a fallback.
     */
    for (var j = 0; j < possibleIds.length; j++) {
      drawer = document.getElementById(
        possibleIds[j]
      );

      if (drawer) {
        console.log(
          '[QUICK SIZE GUIDE] Global drawer found:',
          possibleIds[j]
        );

        return drawer;
      }
    }

    return document.querySelector(
      '.size-guide-drawer[id^="SizeGuideDrawer"], ' +
      '.drawer[id^="SizeGuideDrawer"]'
    );
  }
  


  /*
   * Remove the final "-modal" suffix from IDs inside the
   * quick-shop size-guide drawer, then update all matching
   * references such as aria-controls and aria-labelledby.
   *
   * The root drawer ID stays unchanged so the Quick Shop
   * trigger can still locate SizeGuideDrawer-modal.
   */
  function normalizeSizeGuideInnerIds(drawer) {
    if (!drawer) return;

    if (
      drawer.dataset.sizeGuideIdsNormalized === 'true'
    ) {
      return;
    }

    var idMap = {};

    drawer
      .querySelectorAll('[id$="-modal"]')
      .forEach(function (element) {
        /*
         * Keep the outer drawer ID unchanged:
         * SizeGuideDrawer-modal
         */
        if (element === drawer) return;

        var oldId = element.getAttribute('id');
        var newId = oldId.replace(/-modal$/, '');

        if (!newId || oldId === newId) return;

        idMap[oldId] = newId;
        element.setAttribute('id', newId);
      });

    function updateReferences(value) {
      if (!value) return value;

      return value
        .split(/\s+/)
        .map(function (reference) {
          var hasHash =
            reference.charAt(0) === '#';

          var cleanReference = hasHash
            ? reference.substring(1)
            : reference;

          if (!idMap[cleanReference]) {
            return reference;
          }

          return hasHash
            ? '#' + idMap[cleanReference]
            : idMap[cleanReference];
        })
        .join(' ');
    }

    var referenceAttributes = [
      'for',
      'aria-controls',
      'aria-labelledby',
      'aria-describedby',
      'data-controls',
      'data-target',
      'href'
    ];

    drawer
      .querySelectorAll('*')
      .forEach(function (element) {
        referenceAttributes.forEach(function (
          attribute
        ) {
          var currentValue =
            element.getAttribute(attribute);

          if (!currentValue) return;

          var updatedValue =
            updateReferences(currentValue);

          if (updatedValue !== currentValue) {
            element.setAttribute(
              attribute,
              updatedValue
            );
          }
        });
      });

    drawer.dataset.sizeGuideIdsNormalized =
      'true';

    console.log(
      '[QUICK SIZE GUIDE] Inner IDs normalized:',
      idMap
    );
  }


  /*
   * Initialize the tab buttons inside the Quick Shop size-guide drawer.
   * The original inline size-guide script is not executed when Quick Shop
   * injects the product HTML, so the standalone overlay script handles it.
   */
  function initializeSizeGuideTabs(drawer) {
    if (!drawer) return;

    if (
      drawer.dataset.quickSizeGuideTabsReady === 'true'
    ) {
      return;
    }

    var tabs = Array.from(
      drawer.querySelectorAll('[data-size-guide-tab]')
    );

    var panels = Array.from(
      drawer.querySelectorAll('[data-size-guide-panel]')
    );

    if (!tabs.length || !panels.length) {
      return;
    }

    drawer.dataset.quickSizeGuideTabsReady = 'true';

    function activateTab(selectedTab) {
      var index = selectedTab.getAttribute('data-index');

      var selectedPanel = drawer.querySelector(
        '[data-size-guide-panel][data-index="' +
          index +
          '"]'
      );

      if (!selectedPanel) {
        return;
      }

      tabs.forEach(function (tab) {
        var isSelected = tab === selectedTab;

        tab.classList.toggle(
          'is-active',
          isSelected
        );

        tab.setAttribute(
          'aria-selected',
          isSelected ? 'true' : 'false'
        );

        tab.setAttribute(
          'tabindex',
          isSelected ? '0' : '-1'
        );
      });

      panels.forEach(function (panel) {
        var isSelected = panel === selectedPanel;

        panel.hidden = !isSelected;
        panel.classList.toggle(
          'is-active',
          isSelected
        );

        panel.classList.remove(
          'is-entering',
          'is-leaving'
        );
      });
    }

    tabs.forEach(function (tab, tabIndex) {
      tab.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        activateTab(tab);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = tabIndex;

        if (
          event.key === 'ArrowRight' ||
          event.key === 'ArrowDown'
        ) {
          nextIndex = (tabIndex + 1) % tabs.length;
        } else if (
          event.key === 'ArrowLeft' ||
          event.key === 'ArrowUp'
        ) {
          nextIndex =
            (tabIndex - 1 + tabs.length) %
            tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();

        tabs[nextIndex].focus();
        activateTab(tabs[nextIndex]);
      });
    });

    var initialTab =
      drawer.querySelector(
        '[data-size-guide-tab].is-active'
      ) || tabs[0];

    activateTab(initialTab);

    console.log(
      '[QUICK SIZE GUIDE] Tabs initialized:',
      tabs.length
    );
  }

  function openDrawer(button, drawer) {
    if (!drawer) return;

    /*
     * Normalize only the internal IDs of this Quick Shop
     * size-guide drawer before it is opened.
     */
    normalizeSizeGuideInnerIds(drawer);
    initializeSizeGuideTabs(drawer);

    if (
      activeDrawer &&
      activeDrawer !== drawer
    ) {
      closeDrawer();
    }

    activeDrawer = drawer;
    activeButton = button;

    originalParent = drawer.parentNode;
    originalNextSibling = drawer.nextSibling;

    /*
     * Move the drawer outside the Quick Shop modal.
     * This prevents overflow clipping and stacking issues.
     */
    if (drawer.parentNode !== document.body) {
      document.body.appendChild(drawer);
    }

    drawer.classList.add(
      'quick-shop-size-guide-drawer',
      'drawer--is-open'
    );

    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('aria-modal', 'true');

    button.setAttribute(
      'aria-expanded',
      'true'
    );

    var overlay = getOverlay();

    overlay.classList.add('is-open');
    overlay.setAttribute(
      'aria-hidden',
      'false'
    );

    /*
     * Do not dispatch drawerOpen.
     * Impulse listens for that event and closes the Quick Shop modal.
     */
    document.documentElement.classList.add(
      'js-drawer-open'
    );

    var closeButton = drawer.querySelector(
      '.js-drawer-close, ' +
      '[data-drawer-close], ' +
      '.drawer__close-button, ' +
      '[aria-label="Close"], ' +
      '[aria-label="Close drawer"]'
    );

    if (closeButton) {
      window.setTimeout(function () {
        try {
          closeButton.focus({
            preventScroll: true
          });
        } catch (error) {
          closeButton.focus();
        }
      }, 50);
    }

    console.log(
      '[QUICK SIZE GUIDE] Drawer opened:',
      drawer.id
    );
  }

  function restoreDrawerPosition(drawer) {
    if (!drawer || !originalParent) return;

    if (
      originalNextSibling &&
      originalNextSibling.parentNode === originalParent
    ) {
      originalParent.insertBefore(
        drawer,
        originalNextSibling
      );
    } else {
      originalParent.appendChild(drawer);
    }
  }

  function closeDrawer() {
    if (!activeDrawer) return;

    var drawer = activeDrawer;
    var button = activeButton;

    drawer.classList.remove(
      'drawer--is-open',
      'quick-shop-size-guide-drawer'
    );

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    var overlay = getOverlay();

    overlay.classList.remove('is-open');
    overlay.setAttribute(
      'aria-hidden',
      'true'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'false'
      );

      window.setTimeout(function () {
        try {
          button.focus({
            preventScroll: true
          });
        } catch (error) {
          button.focus();
        }
      }, 50);
    }

    restoreDrawerPosition(drawer);

    /*
     * Only remove the drawer-open class when no other
     * drawer remains open.
     */
    if (
      !document.querySelector(
        '.drawer.drawer--is-open:not(.quick-shop-size-guide-drawer)'
      )
    ) {
      document.documentElement.classList.remove(
        'js-drawer-open'
      );
    }

    console.log(
      '[QUICK SIZE GUIDE] Drawer closed'
    );

    activeDrawer = null;
    activeButton = null;
    originalParent = null;
    originalNextSibling = null;
  }

  /*
   * Capture mode runs before the theme's existing click handler.
   */
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest(
        BUTTON_SELECTOR
      );

      if (button) {
        var quickModal = getQuickModal(button);

        /*
         * Leave the normal PDP size guide untouched.
         */
        if (!quickModal) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var drawer = findDrawer(button);

        if (!drawer) {
          console.warn(
            '[QUICK SIZE GUIDE] Drawer not found.',
            {
              ariaControls:
                button.getAttribute(
                  'aria-controls'
                ),
              searchedIds:
                getPossibleDrawerIds(button)
            }
          );

          return;
        }

        openDrawer(button, drawer);
        return;
      }

      var closeButton = event.target.closest(
        '.quick-shop-size-guide-drawer ' +
        '.js-drawer-close, ' +
        '.quick-shop-size-guide-drawer ' +
        '[data-drawer-close], ' +
        '.quick-shop-size-guide-drawer ' +
        '.drawer__close-button, ' +
        '.quick-shop-size-guide-drawer ' +
        '[aria-label="Close"], ' +
        '.quick-shop-size-guide-drawer ' +
        '[aria-label="Close drawer"]'
      );

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closeDrawer();
      }
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Escape' &&
        activeDrawer
      ) {
        event.preventDefault();
        closeDrawer();
      }
    }
  );

  addStyles();

  console.log(
    '[QUICK SIZE GUIDE] Overlay script loaded'
  );
})();